export enum SortColumn {
  PUBLISH_DATE = 'releaseDate',
  LENGTH = 'duration',
}

export enum SortOrder {
  ASC = 'ascending',
  DESC = 'descending',
}

export type SortColumnState = {
  column: SortColumn;
  order: SortOrder;
};
